exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-widget #header-search {\n  border-radius: 20px 0 0 20px;\n  border-right: none;\n  padding-left: 20px;\n}\n.search-widget .input-group-append .input-group-text {\n  border-radius: 0 20px 20px 0;\n  border-left: none;\n  background: none;\n}\n.search-widget .input-group-append .input-group-text .fa {\n  font-size: 1.1rem;\n}\n.search-widget .search-preview {\n  background: white;\n  z-index: 1000;\n  min-width: 50vw;\n  right: 20px;\n  padding: 20px;\n  margin-top: 10px;\n  max-height: 80vh;\n  overflow-y: scroll;\n}", ""]);

// exports
exports.locals = {
	"primary": "#aa4121",
	"secondary": "#ccc",
	"gray": "#636363"
};